import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { xxllncColor } from '../../layout/theme/color'
import { SmallCard } from './SmallCard'
import { drawGauge } from './animations'

export const CompactGauge: FC<{ rate: number; label: string; delay: number }> = ({
  rate,
  label,
  delay,
}) => {
  const circumference = 2 * Math.PI * 32
  const offset = circumference - (Math.min(rate, 100) / 100) * circumference
  const color =
    rate > 5
      ? xxllncColor.red100
      : rate > 2
        ? xxllncColor.orange100
        : xxllncColor.green100
  return (
    <SmallCard delay={delay} sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
      <Box sx={{ position: 'relative', width: 68, height: 68, flexShrink: 0 }}>
        <svg viewBox="0 0 68 68" width="68" height="68">
          <circle cx="34" cy="34" r="32" fill="none" stroke="rgba(0,0,0,0.04)" strokeWidth="5" />
          <circle cx="34" cy="34" r="32" fill="none" stroke={color} strokeWidth="5"
            strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset}
            transform="rotate(-90 34 34)"
            style={{ animation: `${drawGauge} 1s ease-out ${delay + 200}ms both` }}
          />
        </svg>
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 700,
              color,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {rate}%
          </Typography>
        </Box>
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: 'rgba(0,0,0,0.35)',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
        <Typography sx={{ fontSize: 12, color: 'rgba(0,0,0,0.3)', mt: 0.25 }}>
          {rate <= 2 ? 'Gezond' : rate <= 5 ? 'Aandacht nodig' : 'Kritiek'}
        </Typography>
      </Box>
    </SmallCard>
  )
}
